import { createFileRoute } from '@tanstack/react-router'
import { AdministrationChooserPage } from '@/pages/administration/administration-chooser-page'

export const Route = createFileRoute('/administration/')({
  component: AdministrationChooserPage,
})
